import React, { Suspense } from 'react'
import PropTypes from 'prop-types'
import PortalLoader from '@nexidigital/portalloader'
import { connect } from 'react-redux'
import { Components } from 'Route/routes'
import rootStore from 'Store/createStore'
import { injectReducer } from 'Store/reducers'
import { injectSaga } from 'Store/sagas'

export const LazyComponent = (props) => {
  const { componentName, pluginReducer, pluginSaga, hasReducer, hasSaga, isLoading, noAuth } = props

  if (pluginReducer === undefined && hasReducer) {
    import(/* webpackChunkName: "[request]" */ `Route/${componentName}/modules/${componentName}Reducers`).then(
      ({ default: reducer }) => {
        if (reducer !== undefined) {
          injectReducer(rootStore, { key: componentName, asyncReducer: reducer })
        }
      }
    )
  }

  if (pluginSaga === undefined && hasSaga) {
    import(/* webpackChunkName: "[request]" */ `Route/${componentName}/modules/${componentName}Sagas`).then(
      ({ default: saga }) => {
        if (saga !== undefined) {
          injectSaga(rootStore, { key: componentName, asyncSaga: saga })
        }
      }
    )
  }

  if (pluginReducer) {
    injectReducer(rootStore, { key: componentName, asyncReducer: pluginReducer })
  }

  if (pluginSaga) {
    injectSaga(rootStore, { key: `${componentName}`, asyncSaga: pluginSaga })
  }
  const Component = Components[componentName]
  return (
    <Suspense
      fallback={
        <div style={{ height: '100vh' }} className={`${noAuth ? 'noAuth' : ''}`}>
          <PortalLoader centered />
        </div>
      }>
      {/* necessary to avoid the loader to be displayed on the screen */}
      {isLoading ? (
        <div style={{ height: '100vh' }} className={`${noAuth ? 'noAuth' : ''}`}>
          <PortalLoader centered />
        </div>
      ) : (
        <Component {...props} />
      )}
    </Suspense>
  )
}

const mapStateToProps = (state) => ({
  isLoading: state.loading?.local_userProfile || false
})

LazyComponent.propTypes = {
  componentName: PropTypes.string.isRequired,
  pluginReducer: PropTypes.func,
  pluginSaga: PropTypes.func,
  hasReducer: PropTypes.bool,
  hasSaga: PropTypes.bool,
  isLoading: PropTypes.bool,
  noAuth: PropTypes.bool
}

LazyComponent.defaultProps = {
  pluginReducer: undefined,
  pluginSaga: undefined,
  hasReducer: false,
  hasSaga: false,
  isLoading: false,
  noAuth: false
}

export default connect(mapStateToProps)(LazyComponent)
